import { render, staticRenderFns } from "./ShopWindowWidth.vue?vue&type=template&id=2eec679e&"
import script from "./ShopWindowWidth.vue?vue&type=script&lang=ts&"
export * from "./ShopWindowWidth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports